import { GetServerSidePropsResult } from 'next'

import { UserProps } from '@backend/ssr/serverSideProps'

import { ViewContext } from '@shared/const'

import { User } from '@shared-types/domain'

export const isUserSupplierOrTransporter = (user: User) => {
  return user.view_context === ViewContext.SUPPLIER || user.view_context === ViewContext.TRANSPORTER
}

export const isUserOwner = (user: User) => {
  return user.view_context === ViewContext.OWNER
}

export const isUserSupplier = (user: User) => {
  return user.view_context === ViewContext.SUPPLIER
}

export const isUserTransporter = (user: User) => {
  return user.view_context === ViewContext.TRANSPORTER
}

export const redirectShipmentCreationBasedOnUserContext = (
  user: User
): GetServerSidePropsResult<UserProps> => {
  if (isUserOwner(user)) {
    return {
      redirect: {
        destination: '/shipments/create/owners',
        permanent: false,
      },
    }
  }
  if (isUserSupplier(user)) {
    return {
      redirect: {
        destination: '/shipments/create/suppliers',
        permanent: false,
      },
    }
  }
  if (isUserTransporter(user)) {
    return {
      redirect: {
        destination: '/shipments/create/transporters',
        permanent: false,
      },
    }
  }

  return {
    notFound: true,
  }
}
